import request from "library/v1/request";

export function showDashboard(params) {
  return request({
    url: 'dashboard',
    method: 'get'
  })
}
